import { LngLat } from 'maplibre-gl';
import config from '../../../config';
import axios from 'axios';
export var OptimizationMvrpPointReturnType;
(function (OptimizationMvrpPointReturnType) {
    OptimizationMvrpPointReturnType["Any"] = "any";
    OptimizationMvrpPointReturnType["Last"] = "last";
})(OptimizationMvrpPointReturnType || (OptimizationMvrpPointReturnType = {}));
function checkAndnormalizeOpt(opt) {
    if (!opt.locations) {
        throw new Error('locations is required in OptimizationMvrpOrderRequest');
    }
    if (!Array.isArray(opt.vehicles) || opt.vehicles.length === 0) {
        throw new Error('vehicles is required in OptimizationMvrpOrderRequest');
    }
    const nOpt = Object.assign({}, opt, {
        locations: {
            id: opt.locations.id,
            location: opt.locations.location
                .map((point) => LngLat.convert(point))
                .map((point) => `${point.lat},${point.lng}`)
                .join('|'),
        },
    });
    return nOpt;
}
/**
 * A service solves for the optimization of a Multi(or single) vehicle routing problem.
 */
export class OptimizationMvrpService {
    async postVRP(opt) {
        const nOpt = checkAndnormalizeOpt(opt);
        if (!config.API_KEY) {
            throw new Error('In order to call the NextBillion.ai API, you must provide a valid API Key.');
        }
        if (!config.API_HOST) {
            throw new Error('An API host is required to make request to NextBillion.ai API.');
        }
        const params = {
            description: nOpt.description,
            locations: nOpt.locations,
            vehicles: nOpt.vehicles,
        };
        if (nOpt.mode) {
            params.mode = nOpt.mode;
        }
        if (nOpt.jobs) {
            params.jobs = nOpt.jobs;
        }
        if (nOpt.shipments) {
            params.shipments = nOpt.shipments;
        }
        if (nOpt.depots) {
            params.depots = nOpt.depots;
        }
        return await axios
            .post(`https://${config.API_HOST}/optimise-mvrp?key=${config.API_KEY}`, params)
            .then((resp) => resp.data)
            .catch((err) => {
            if (err.response && err.response.data) {
                return err.response.data;
            }
            else {
                return err;
            }
        });
    }
    async retrieve(opt) {
        if (!opt.id || typeof opt.id !== 'string') {
            throw new Error('id is required in OptimizationMvrpRetrieveRequest');
        }
        if (!config.API_KEY) {
            throw new Error('In order to call the NextBillion.ai API, you must provide a valid API Key.');
        }
        if (!config.API_HOST) {
            throw new Error('An API host is required to make request to NextBillion.ai API.');
        }
        const params = {
            key: config.API_KEY,
            id: opt.id,
        };
        return await axios
            .get(`https://${config.API_HOST}/optimise-mvrp/result`, {
            params,
        })
            .then((resp) => resp.data)
            .catch((err) => {
            if (err.response && err.response.data) {
                return err.response.data;
            }
            else {
                return err;
            }
        });
    }
}
//# sourceMappingURL=optimization-mvrp.js.map